// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__35E1_","search":"Settings_search__9Hr_j","filter":"Settings_filter__2TUGt"};